<template>
    <div class="Import" app>
        <Navbar />
        <v-content>
            <div style="margin: 10px 16px;">
                <v-card style="overflow-x:hidden" flat :dark="customization.dark">
                    <v-card-title>Importação de {{title[type]}}</v-card-title>
                    <v-row style="padding: 0px 16px">
                        <v-col cols="10">
                            <v-file-input
                                name="file"
                                show-size
                                label="Arquivo de Importação"
                                outlined
                                v-model="file"
                            ></v-file-input>
                        </v-col>
                        <v-col cols="2">
                            <v-btn
                                x-large
                                :color="customization.mainBtnColor"
                                :dark="customization.mainBtnDark"
                                width="100%"
                                @click="importFile"
                            >Importar</v-btn>
                        </v-col>
                        <v-col cols="12">
                            <span style="color: red">{{error}}</span>
                        </v-col>
                    </v-row>
                </v-card>
            </div>
        </v-content>
    </div>
</template>

<script>
import Navbar       from '@/components/Navbar.vue';
import api          from '@/plugins/apisauce.js';
import router       from '@/router/index.js';

export default {
    name: 'Importa',
    components:{
        Navbar,
    },
    data: () => ({
        customization: {},
        title:{
            cargas: "Cargas"
        },
        type: "",
        error: "",
        file: null
    }),
    watch: {
        '$route.params.type': function () {
            this.loadPage();
        }
    },
    methods:{
        loadPage(){
            this.type = this.$route.params.type;
            if(!this.title[this.type]) router.push('/dashboard');
        },
        importFile(){
            const form = new FormData()
            form.append('file', this.file)
            const headers = {
                'Content-Type': 'multipart/form-data',
                'Accept':'multipart/form-data'
            }
            api.post(`import/file/${localStorage.getItem("idcliente")}`, form, { headers }).then(r=>{
                console.log(r);
            })
        }
    },
    mounted(){
        if(!localStorage.getItem("usrId")) router.push('/');
        this.customization = JSON.parse(localStorage.getItem("customization"));
        this.loadPage();
        document.title = `${this.customization.name} - Importação de ${this.title[this.type]}`;
    }
}
</script>